export default __webpack_public_path__ + "61cc5ee9128ca9a8d9c476a21849a000.glb";